// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2UUjg","dragIcon":"SortableItem_dragIcon__EPn6e","disabled":"SortableItem_disabled__14l_1"};